import { ProductInfoProduct } from '../../types'
import { EMPTY_STATE, type ProductModalState } from './types'

type ModalAction =
  | { type: 'SHOW'; payload: Omit<ProductModalState, 'isOpen'> }
  | { type: 'SHOW_PRODUCT'; product: ProductInfoProduct }
  | { type: 'RESTORE_PRODUCT'; product: ProductInfoProduct }
  | { type: 'CLOSE' }

export const modalStateReducer = (
  state: ProductModalState,
  action: ModalAction,
): ProductModalState => {
  switch (action.type) {
    case 'SHOW':
      return {
        ...action.payload,
        isOpen: true,
      }

    case 'SHOW_PRODUCT':
    case 'RESTORE_PRODUCT':
      return {
        ...state,
        product: action.product,
        upsellProduct: undefined,
        isOpen: true,
      }

    case 'CLOSE':
      return EMPTY_STATE
  }
}
